require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.promise");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.reflect.get");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.Particles = t(require("react")) : e.Particles = t(e.React);
}(this, function (e) {
  return function (e) {
    var t = {};

    function i(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
    }

    return i.m = e, i.c = t, i.d = function (e, t, n) {
      i.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, i.t = function (e, t) {
      if (1 & t && (e = i(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (i.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        i.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, i.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return i.d(t, "a", t), t;
    }, i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.p = "", i(i.s = 27);
  }([function (e, t, i) {
    var n = i(18),
        r = "object" == typeof self && self && self.Object === Object && self,
        a = n || r || Function("return this")();
    e.exports = a;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), function (e) {
      e.CIRCLE = "circle", e.EDGE = "edge", e.TRIANGLE = "triangle", e.POLYGON = "polygon", e.STAR = "star", e.IMAGE = "image", e.IMAGES = "images";
    }(t.ShapeType || (t.ShapeType = {})), function (e) {
      e.TOP = "top", e.TOP_RIGHT = "top-right", e.RIGHT = "right", e.BOTTOM_RIGHT = "bottom-right", e.BOTTOM = "bottom", e.BOTTOM_LEFT = "bottom-left", e.LEFT = "left", e.TOP_LEFT = "top-left", e.NONE = "none";
    }(t.MoveDirection || (t.MoveDirection = {})), function (e) {
      e.BOUNCE = "bounce", e.OUT = "out";
    }(t.MoveOutMode || (t.MoveOutMode = {})), function (e) {
      e.GRAB = "grab", e.PUSH = "push", e.REMOVE = "remove", e.BUBBLE = "bubble", e.REPULSE = "repulse";
    }(t.InteractivityMode || (t.InteractivityMode = {})), function (e) {
      e.INLINE = "inline", e.INSIDE = "inside", e.OUTSIDE = "outside";
    }(t.PolygonType || (t.PolygonType = {})), function (e) {
      e.RANDOM_POINT = "random-point", e.ONE_PER_POINT = "one-per-point", e.RANDOM_LENGTH = "random-length", e.EQUIDISTANT = "equidistant";
    }(t.PolygonInlineArrangementType || (t.PolygonInlineArrangementType = {})), function (e) {
      e.PATH = "path", e.RADIUS = "radius";
    }(t.PolygonMoveType || (t.PolygonMoveType = {}));
  }, function (e, t, i) {
    "use strict";

    function n(e) {
      for (var i in e) {
        t.hasOwnProperty(i) || (t[i] = e[i]);
      }
    }

    var r = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = r(i(15));
    t.Interactivity = a["default"];
    var o = r(i(29));
    t.Modes = o["default"];
    var s = r(i(30));
    t.Particle = s["default"];
    var c = r(i(31));
    t.ParticleManager = c["default"];
    var l = r(i(32));
    t.ParticlesLibrary = l["default"];
    var u = r(i(34));
    t.Vendors = u["default"], n(i(35)), n(i(1)), n(i(36)), n(i(4));
  }, function (e, t, i) {
    var n = i(51),
        r = i(57);

    e.exports = function (e, t) {
      var i = r(e, t);
      return n(i) ? i : void 0;
    };
  }, function (e, t, i) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function r(e, t) {
      return t.indexOf(e) > -1;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.hexToRgb = function (e) {
      e = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (e, t, i, n) {
        return t + t + i + i + n + n;
      });
      var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
      return t ? {
        r: parseInt(t[1], 16),
        g: parseInt(t[2], 16),
        b: parseInt(t[3], 16)
      } : null;
    }, t.clamp = function (e, t, i) {
      return Math.min(Math.max(e, t), i);
    }, t.isInArray = r, t.isEqual = function (e, t) {
      return Array.isArray(t) ? r(e, t) : t === e;
    }, t.deepAssign = function (e) {
      for (var i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++) {
        r[a - 1] = arguments[a];
      }

      for (var o = 0, s = r; o < s.length; o++) {
        var c = s[o];

        if (null != c) {
          var l = n(c);

          if ("object" === l) {
            var u = Array.isArray(c);
            u ? "object" === n(e) && e && Array.isArray(e) || (e = []) : "object" === n(e) && e && !Array.isArray(e) || (e = {});

            var h = function h(i) {
              if ("__proto__" === i) return "continue";
              var r = c[i],
                  a = "object" === n(r);
              a && Array.isArray(r) ? e[i] = r.map(function (n) {
                return t.deepAssign(e[i], n);
              }) : e[i] = t.deepAssign(e[i], r);
            };

            for (var y in c) {
              h(y);
            }
          } else e = c;
        }
      }

      return e;
    };

    t.getColor = function (e) {
      var i = {};

      if ("object" == n(e)) {
        if (e instanceof Array) {
          var r = e[Math.floor(Math.random() * e.length)];
          i.rgb = t.hexToRgb(r);
        } else if (function (e) {
          return "object" === n(e) && "r" in e && "g" in e && "b" in e;
        }(e)) {
          var a = e.r,
              o = e.g,
              s = e.b;
          i.rgb = {
            r: a,
            g: o,
            b: s
          };
        } else if (function (e) {
          return "object" === n(e) && "h" in e && "s" in e && "l" in e;
        }(e)) {
          var c = e.h,
              l = e.s,
              u = e.l;
          i.hsl = {
            h: c,
            s: l,
            l: u
          };
        }
      } else "random" == e ? i.rgb = {
        r: Math.floor(255 * Math.random()) + 1,
        g: Math.floor(255 * Math.random()) + 1,
        b: Math.floor(255 * Math.random()) + 1
      } : "string" == typeof e && (i.rgb = t.hexToRgb(e));

      return i;
    };
  }, function (e, t, i) {
    var n = i(41),
        r = i(42),
        a = i(43),
        o = i(44),
        s = i(45);

    function c(e) {
      var t = -1,
          i = null == e ? 0 : e.length;

      for (this.clear(); ++t < i;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    c.prototype.clear = n, c.prototype["delete"] = r, c.prototype.get = a, c.prototype.has = o, c.prototype.set = s, e.exports = c;
  }, function (e, t, i) {
    var n = i(16);

    e.exports = function (e, t) {
      for (var i = e.length; i--;) {
        if (n(e[i][0], t)) return i;
      }

      return -1;
    };
  }, function (e, t, i) {
    var n = i(12),
        r = i(53),
        a = i(54),
        o = n ? n.toStringTag : void 0;

    e.exports = function (e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : o && o in Object(e) ? r(e) : a(e);
    };
  }, function (e, t, i) {
    var n = i(3)(Object, "create");
    e.exports = n;
  }, function (e, t, i) {
    var n = i(66);

    e.exports = function (e, t) {
      var i = e.__data__;
      return n(t) ? i["string" == typeof t ? "string" : "hash"] : i.map;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, i) {
    var n = i(3)(i(0), "Map");
    e.exports = n;
  }, function (e, t, i) {
    var n = i(0).Symbol;
    e.exports = n;
  }, function (e, t) {
    var i = Array.isArray;
    e.exports = i;
  }, function (t, i) {
    t.exports = e;
  }, function (e, t, i) {
    "use strict";

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        a = i(1);
    !function (e) {
      e.MOUSEMOVE = "mousemove", e.MOUSELEAVE = "mouseleave";
    }(r = t.MouseInteractivityStatus || (t.MouseInteractivityStatus = {}));

    var o = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.library = t, this.mouseMovePosition = {
          x: 0,
          y: 0
        }, this.mouseClickPosition = {
          x: 0,
          y: 0
        }, this.mouseClickTime = 0, this.onMouseMove = this.onMouseMove.bind(this), this.onMouseLeave = this.onMouseLeave.bind(this), this.onMouseClick = this.onMouseClick.bind(this);
      }

      var t, i, o;
      return t = e, (i = [{
        key: "attachEventHandlers",
        value: function value() {
          var e = this.library.getParameter(function (e) {
            return e.interactivity;
          });
          "window" === e.detect_on ? this.interactionElement = window : this.interactionElement = this.library.canvas.element, (e.events.onhover.enable || e.events.onclick.enable) && (this.interactionElement.addEventListener("mousemove", this.onMouseMove), this.interactionElement.addEventListener("mouseleave", this.onMouseLeave)), e.events.onclick.enable && this.interactionElement.addEventListener("click", this.onMouseClick);
        }
      }, {
        key: "detachEventHandlers",
        value: function value() {
          var e = this.library.getParameter(function (e) {
            return e.interactivity;
          });
          this.interactionElement && ((e.events.onhover.enable || e.events.onclick.enable) && (this.interactionElement.removeEventListener("mousemove", this.onMouseMove), this.interactionElement.removeEventListener("mouseleave", this.onMouseLeave)), e.events.onclick.enable && this.interactionElement.removeEventListener("click", this.onMouseClick));
        }
      }, {
        key: "onMouseMove",
        value: function value(e) {
          var t = {
            x: 0,
            y: 0
          };
          this.interactionElement === window ? (t.x = e.clientX, t.y = e.clientY) : (t.x = e.offsetX || e.clientX, t.y = e.offsetY || e.clientY), this.mouseMovePosition = t, this.library.retina && (this.mouseMovePosition.x *= this.library.canvas.pxratio, this.mouseMovePosition.y *= this.library.canvas.pxratio), this.mouseStatus = r.MOUSEMOVE;
        }
      }, {
        key: "onMouseLeave",
        value: function value() {
          this.mouseMovePosition.x = 0, this.mouseMovePosition.y = 0, this.mouseStatus = r.MOUSELEAVE;
        }
      }, {
        key: "onMouseClick",
        value: function value() {
          var e = this,
              t = this.library.getParameter(function (e) {
            return e.interactivity;
          }),
              i = this.library.getParameter(function (e) {
            return e.particles;
          }),
              n = this.library.getParameter(function (e) {
            return e.polygon;
          });

          if (this.mouseClickPosition = Object.assign({}, this.mouseMovePosition), n.enable && [a.PolygonType.INSIDE, a.PolygonType.OUTSIDE].indexOf(n.type) > -1) {
            var r = this.library.polygonMask.isPointInsidePolygon(this.mouseClickPosition);
            if (n.type === a.PolygonType.INSIDE && !r) return;
            if (n.type === a.PolygonType.OUTSIDE && r) return;
          }

          if (this.mouseClickTime = new Date().getTime(), t.events.onclick.enable) switch (t.events.onclick.mode) {
            case a.InteractivityMode.PUSH:
              i.move.enable ? this.library.modes.pushParticles(t.modes.push.particles_nb, this.mouseClickPosition) : 1 == t.modes.push.particles_nb ? this.library.modes.pushParticles(t.modes.push.particles_nb, this.mouseClickPosition) : t.modes.push.particles_nb > 1 && this.library.modes.pushParticles(t.modes.push.particles_nb);
              break;

            case a.InteractivityMode.REMOVE:
              this.library.modes.removeParticles(t.modes.remove.particles_nb);
              break;

            case a.InteractivityMode.BUBBLE:
              this.library.modes.bubble_clicking = !0;
              break;

            case a.InteractivityMode.REPULSE:
              this.library.modes.repulse_clicking = !0, this.library.modes.repulse_count = 0, this.library.modes.repulse_finish = !1, setTimeout(function () {
                e.library.modes.repulse_clicking = !1;
              }, 1e3 * t.modes.repulse.duration);
          }
        }
      }, {
        key: "linkParticles",
        value: function value(e, t) {
          var i = this.library.manager.getDistance(e, t),
              n = this.library.canvas,
              r = this.library.getParameter(function (e) {
            return e.particles.line_linked;
          });

          if (i <= r.distance) {
            var a = r.opacity - i / (1 / r.opacity) / r.distance;

            if (a > 0) {
              var o = r.color_rgb_line,
                  s = o.r,
                  c = o.g,
                  l = o.b;
              n.ctx.save(), n.ctx.strokeStyle = "rgba( ".concat(s, ", ").concat(c, ", ").concat(l, ", ").concat(a, " )"), n.ctx.lineWidth = r.width, n.ctx.beginPath(), r.shadow.enable && (n.ctx.shadowBlur = r.shadow.blur, n.ctx.shadowColor = r.shadow.color), n.ctx.moveTo(e.x, e.y), n.ctx.lineTo(t.x, t.y), n.ctx.stroke(), n.ctx.closePath(), n.ctx.restore();
            }
          }
        }
      }, {
        key: "attractParticles",
        value: function value(e, t) {
          var i = this.library.manager.getDistances(e, t),
              n = i.distance,
              r = i.distanceX,
              a = i.distanceY,
              o = this.library.getParameter(function (e) {
            return e.particles.line_linked;
          }),
              s = this.library.getParameter(function (e) {
            return e.particles.move.attract;
          });

          if (n <= o.distance) {
            var c = r / (1e3 * s.rotateX),
                l = a / (1e3 * s.rotateY);
            e.vx -= c, e.vy -= l, t.vx += c, t.vy += l;
          }
        }
      }, {
        key: "bounceParticles",
        value: function value(e, t) {
          this.library.manager.getDistance(e, t) <= e.radius + t.radius && (e.vx = -e.vx, e.vy = -e.vy, t.vx = -t.vx, t.vy = -t.vy);
        }
      }]) && n(t.prototype, i), o && n(t, o), e;
    }();

    t["default"] = o;
  }, function (e, t) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, i) {
    var n = i(7),
        r = i(19);

    e.exports = function (e) {
      if (!r(e)) return !1;
      var t = n(e);
      return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    };
  }, function (e, t, i) {
    (function (t) {
      var i = "object" == typeof t && t && t.Object === Object && t;
      e.exports = i;
    }).call(this, i(52));
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t) {
    var i = Function.prototype.toString;

    e.exports = function (e) {
      if (null != e) {
        try {
          return i.call(e);
        } catch (e) {}

        try {
          return e + "";
        } catch (e) {}
      }

      return "";
    };
  }, function (e, t, i) {
    var n = i(58),
        r = i(65),
        a = i(67),
        o = i(68),
        s = i(69);

    function c(e) {
      var t = -1,
          i = null == e ? 0 : e.length;

      for (this.clear(); ++t < i;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    c.prototype.clear = n, c.prototype["delete"] = r, c.prototype.get = a, c.prototype.has = o, c.prototype.set = s, e.exports = c;
  }, function (e, t, i) {
    var n = i(70),
        r = i(73),
        a = i(74);

    e.exports = function (e, t, i, o, s, c) {
      var l = 1 & i,
          u = e.length,
          h = t.length;
      if (u != h && !(l && h > u)) return !1;
      var y = c.get(e);
      if (y && c.get(t)) return y == t;
      var p = -1,
          f = !0,
          v = 2 & i ? new n() : void 0;

      for (c.set(e, t), c.set(t, e); ++p < u;) {
        var d = e[p],
            b = t[p];
        if (o) var g = l ? o(b, d, p, t, e, c) : o(d, b, p, e, t, c);

        if (void 0 !== g) {
          if (g) continue;
          f = !1;
          break;
        }

        if (v) {
          if (!r(t, function (e, t) {
            if (!a(v, t) && (d === e || s(d, e, i, o, c))) return v.push(t);
          })) {
            f = !1;
            break;
          }
        } else if (d !== b && !s(d, b, i, o, c)) {
          f = !1;
          break;
        }
      }

      return c["delete"](e), c["delete"](t), f;
    };
  }, function (e, t, i) {
    (function (e) {
      var n = i(0),
          r = i(91),
          a = t && !t.nodeType && t,
          o = a && "object" == typeof e && e && !e.nodeType && e,
          s = o && o.exports === a ? n.Buffer : void 0,
          c = (s ? s.isBuffer : void 0) || r;
      e.exports = c;
    }).call(this, i(24)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, i) {
    var n = i(93),
        r = i(94),
        a = i(95),
        o = a && a.isTypedArray,
        s = o ? r(o) : n;
    e.exports = s;
  }, function (e, t) {
    e.exports = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
    };
  }, function (e, t, i) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(i(28));
    t.Particles = r["default"], t["default"] = r["default"];
  }, function (e, t, i) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function a(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function o(e, t, i) {
      return (o = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, i) {
        var n = function (e, t) {
          for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = s(e));) {
            ;
          }

          return e;
        }(e, t);

        if (n) {
          var r = Object.getOwnPropertyDescriptor(n, t);
          return r.get ? r.get.call(i) : r.value;
        }
      })(e, t, i || e);
    }

    function s(e) {
      return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function c(e, t) {
      return (c = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var l = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var i in e) {
        Object.hasOwnProperty.call(e, i) && (t[i] = e[i]);
      }
      return t["default"] = e, t;
    },
        u = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var h = l(i(14)),
        y = i(14),
        p = i(2),
        f = u(i(37)),
        v = function (e) {
      function t(e) {
        var i;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (i = function (e, t) {
          return !t || "object" !== n(t) && "function" != typeof t ? a(e) : t;
        }(this, s(t).call(this, e))).state = {
          canvas: void 0,
          library: void 0
        }, i.loadCanvas = i.loadCanvas.bind(a(i)), i;
      }

      var i, l, u;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && c(e, t);
      }(t, e), i = t, (l = [{
        key: "buildParticlesLibrary",
        value: function value(e) {
          try {
            if (void 0 === window) return null;
          } catch (e) {
            return null;
          }

          return new p.ParticlesLibrary(e);
        }
      }, {
        key: "refresh",
        value: function value(e) {
          var t = this,
              i = this.state.canvas;
          i && (this.destroy(), this.setState({
            library: this.buildParticlesLibrary(e.params)
          }, function () {
            t.loadCanvas(i);
          }));
        }
      }, {
        key: "destroy",
        value: function value() {
          this.state.library && this.state.library.destroy();
        }
      }, {
        key: "loadCanvas",
        value: function value(e) {
          var t = this;
          e && this.setState({
            canvas: e
          }, function () {
            var i = t.state.library;
            i && (i.loadCanvas(e), i.start());
          });
        }
      }, {
        key: "shouldComponentUpdate",
        value: function value(e) {
          return !f["default"](e, this.props);
        }
      }, {
        key: "componentDidUpdate",
        value: function value() {
          this.refresh(this.props);
        }
      }, {
        key: "forceUpdate",
        value: function value() {
          this.refresh(this.props), o(s(t.prototype), "forceUpdate", this).call(this);
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          this.setState({
            library: this.buildParticlesLibrary(this.props.params)
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.destroy(), this.setState({
            library: void 0
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.width,
              i = e.height,
              n = e.className,
              r = e.canvasClassName;
          return h.createElement("div", {
            className: n
          }, h.createElement("canvas", {
            ref: this.loadCanvas,
            className: r,
            style: Object.assign(Object.assign({}, this.props.style), {
              width: t,
              height: i
            })
          }));
        }
      }]) && r(i.prototype, l), u && r(i, u), t;
    }(y.Component);

    t["default"] = v, v.defaultProps = {
      width: "100%",
      height: "100%",
      params: {},
      style: {}
    };
  }, function (e, t, i) {
    "use strict";

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = i(2),
        a = i(1),
        o = i(15),
        s = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.library = t, this.bubble_clicking = !1, this.bubble_duration_end = !1, this.pushing = !1, this.repulse_clicking = !1, this.repulse_count = 0, this.repulse_finish = !1;
      }

      var t, i, s;
      return t = e, (i = [{
        key: "pushParticles",
        value: function value(e, t) {
          var i = this.library.manager,
              n = this.library.getParameter(function (e) {
            return e.particles;
          });
          this.pushing = !0;
          var a = e;
          n.number.max > 0 && (a = n.array.length + e > n.number.max ? n.number.max - n.array.length : e);

          for (var o = 0; o < a; o++) {
            n.array.push(new r.Particle(this.library, {
              position: t
            })), o === e - 1 && (n.move.enable || i.particlesDraw(), this.pushing = !1);
          }
        }
      }, {
        key: "removeParticles",
        value: function value(e) {
          var t = this.library.manager,
              i = this.library.getParameter(function (e) {
            return e.particles;
          });
          i.array.splice(0, e), i.move.enable || t.particlesDraw();
        }
      }, {
        key: "bubbleParticle",
        value: function value(e) {
          var t = this,
              i = this.library.getParameter(function (e) {
            return e.interactivity;
          }),
              n = this.library.getParameter(function (e) {
            return e.particles;
          });

          if (i.events.onhover.enable && r.isInArray(a.InteractivityMode.BUBBLE, i.events.onhover.mode)) {
            var s = this.library.manager.getDistance(e, this.library.interactivity.mouseMovePosition),
                c = i.modes.bubble.distance,
                l = 1 - s / c;

            if (s <= c) {
              if (l >= 0 && this.library.interactivity.mouseStatus === o.MouseInteractivityStatus.MOUSEMOVE) {
                var u = i.modes.bubble.size,
                    h = n.size.value;
                if (u != h) if (u > h) {
                  var y = e.radius + u * l;
                  y >= 0 && (e.radius_bubble = y);
                } else {
                  var p = e.radius - u,
                      f = e.radius - p * l;
                  e.radius_bubble = f > 0 ? f : 0;
                }
                if (i.modes.bubble.opacity !== n.opacity.value) if (i.modes.bubble.opacity > n.opacity.value) {
                  var v = i.modes.bubble.opacity * l;
                  v > e.opacityValue && v <= i.modes.bubble.opacity && (e.bubbleOpacity = v);
                } else {
                  var d = e.opacityValue - (n.opacity.value - i.modes.bubble.opacity) * l;
                  d < e.opacityValue && d >= i.modes.bubble.opacity && (e.bubbleOpacity = d);
                }
              }
            } else e.bubbleOpacity = e.opacityValue, e.radius_bubble = e.radius;

            this.library.interactivity.mouseStatus === o.MouseInteractivityStatus.MOUSELEAVE && (e.bubbleOpacity = e.opacityValue, e.radius_bubble = e.radius);
          } else if (i.events.onclick.enable && r.isInArray(a.InteractivityMode.BUBBLE, i.events.onclick.mode) && this.bubble_clicking) {
            var b = this.library.manager.getDistance(e, this.library.interactivity.mouseClickPosition),
                g = (new Date().getTime() - this.library.interactivity.mouseClickTime) / 1e3;
            g > i.modes.bubble.duration && (this.bubble_duration_end = !0), g > 2 * i.modes.bubble.duration && (this.bubble_clicking = !1, this.bubble_duration_end = !1);

            var m = function m(n, r, a, o, s) {
              if (n != r) if (t.bubble_duration_end) {
                if (null != a) {
                  var c = n + (n - (o - g * (o - n) / i.modes.bubble.duration));
                  "size" == s && (e.radius_bubble = c), "opacity" == s && (e.bubbleOpacity = c);
                }
              } else if (b <= i.modes.bubble.distance) {
                if ((null != a ? a : o) != n) {
                  var l = o - g * (o - n) / i.modes.bubble.duration;
                  "size" == s && (e.radius_bubble = l), "opacity" == s && (e.bubbleOpacity = l);
                }
              } else "size" == s && (e.radius_bubble = void 0), "opacity" == s && (e.bubbleOpacity = void 0);
            };

            this.bubble_clicking && (m(i.modes.bubble.size, n.size.value, e.radius_bubble, e.radius, "size"), m(i.modes.bubble.opacity, n.opacity.value, e.bubbleOpacity, e.opacityValue, "opacity"));
          }
        }
      }, {
        key: "repulseParticle",
        value: function value(e) {
          var t = this.library.canvas,
              i = this.library.getParameter(function (e) {
            return e.interactivity;
          }),
              n = this.library.getParameter(function (e) {
            return e.particles;
          });

          if (i.events.onhover.enable && r.isInArray(a.InteractivityMode.REPULSE, i.events.onhover.mode) && this.library.interactivity.mouseStatus === o.MouseInteractivityStatus.MOUSEMOVE) {
            var s = this.library.manager.getDistances(e, this.library.interactivity.mouseMovePosition),
                c = s.distance,
                l = {
              x: s.distanceX / c,
              y: s.distanceY / c
            },
                u = i.modes.repulse.distance,
                h = r.clamp(1 / u * (-1 * Math.pow(c / u, 2) + 1) * u * 100, 0, 50),
                y = {
              x: e.x + l.x * h,
              y: e.y + l.y * h
            };
            n.move.out_mode === a.MoveOutMode.BOUNCE ? (y.x - e.radius > 0 && y.x + e.radius < t.width && (e.x = y.x), y.y - e.radius > 0 && y.y + e.radius < t.height && (e.y = y.y)) : (e.x = y.x, e.y = y.y);
          } else if (i.events.onclick.enable && r.isInArray(a.InteractivityMode.REPULSE, i.events.onclick.mode)) if (this.repulse_finish || (this.repulse_count++, this.repulse_count == n.array.length && (this.repulse_finish = !0)), this.repulse_clicking) {
            var p = Math.pow(i.modes.repulse.distance / 6, 3),
                f = this.library.manager.getDistances(this.library.interactivity.mouseClickPosition, e),
                v = f.distance,
                d = f.distanceX,
                b = f.distanceY,
                g = p / Math.pow(v, 2) * -1;

            if (v <= p) {
              var m = Math.atan2(b, d);

              if (e.vx = g * Math.cos(m), e.vy = g * Math.sin(m), n.move.out_mode === a.MoveOutMode.BOUNCE) {
                var _ = {
                  x: e.x + e.vx,
                  y: e.y + e.vy
                };
                _.x + e.radius > t.width ? e.vx = -e.vx : _.x - e.radius < 0 && (e.vx = -e.vx), _.y + e.radius > t.height ? e.vy = -e.vy : _.y - e.radius < 0 && (e.vy = -e.vy);
              }
            }
          } else !1 === this.repulse_clicking && (e.vx = e.vx_i, e.vy = e.vy_i);
        }
      }, {
        key: "grabParticle",
        value: function value(e) {
          var t = this.library.canvas,
              i = this.library.getParameter(function (e) {
            return e;
          }),
              n = i.interactivity,
              r = i.particles;

          if (n.events.onhover.enable && this.library.interactivity.mouseStatus === o.MouseInteractivityStatus.MOUSEMOVE) {
            var a = this.library.manager.getDistance(e, this.library.interactivity.mouseMovePosition);

            if (a <= n.modes.grab.distance) {
              var s = n.modes.grab,
                  c = s.line_linked.opacity - a / (1 / s.line_linked.opacity) / s.distance;

              if (c > 0) {
                var l = r.line_linked.color_rgb_line,
                    u = l.r,
                    h = l.g,
                    y = l.b;
                t.ctx.strokeStyle = "rgba( ".concat(u, ", ").concat(h, ", ").concat(y, ", ").concat(c, " )"), t.ctx.lineWidth = r.line_linked.width, t.ctx.beginPath(), t.ctx.moveTo(e.x, e.y), t.ctx.lineTo(this.library.interactivity.mouseMovePosition.x, this.library.interactivity.mouseMovePosition.y), t.ctx.stroke(), t.ctx.closePath();
              }
            }
          }
        }
      }]) && n(t.prototype, i), s && n(t, s), e;
    }();

    t["default"] = s;
  }, function (e, t, i) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = i(2),
        o = i(1),
        s = i(4),
        c = function () {
      function e(t) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = i.color,
            a = i.move,
            o = i.opacity,
            s = i.polygon,
            c = i.position,
            l = i.shape,
            u = i.size;
        n(this, e), this.library = t, this.setupSize(u), this.setupPosition(a, s, c), this.setupColor(r), this.setupOpacity(o), this.setupAnimation(a), this.setupShape(l);
      }

      var t, i, c;
      return t = e, (i = [{
        key: "setupSize",
        value: function value(e) {
          var t = this.library.getParameter(function (e) {
            return e.particles.size;
          });
          e = s.deepAssign({}, t, e), this.radius = (e.random ? Math.random() : 1) * e.value, e.anim.enable && (this.size_status = !1, this.vs = e.anim.speed / 100, e.anim.sync || (this.vs = this.vs * Math.random()));
        }
      }, {
        key: "setupPosition",
        value: function value(e, t, i) {
          this.initialPosition = i;
          var n = this.library.getParameter(function (e) {
            return e.particles.move;
          });
          e = s.deepAssign({}, n, e);
          var r = this.library.getParameter(function (e) {
            return e.polygon;
          });
          t = s.deepAssign({}, r, t);
          var a = this.library.getParameter(function (e) {
            return e.particles.array;
          }),
              c = this.library,
              l = c.canvas,
              u = c.vendors;
          if (i) this.x = i.x, this.y = i.y;else if (t.enable) {
            var h;

            switch (t.type) {
              case o.PolygonType.INLINE:
                switch (t.inline.arrangement) {
                  case o.PolygonInlineArrangementType.RANDOM_POINT:
                    h = this.library.polygonMask.getRandomPointOnPolygonPath();
                    break;

                  case o.PolygonInlineArrangementType.RANDOM_LENGTH:
                    h = this.library.polygonMask.getRandomPointOnPolygonPathByLength();
                    break;

                  case o.PolygonInlineArrangementType.EQUIDISTANT:
                    h = this.library.polygonMask.getEquidistantPoingOnPolygonPathByIndex(a.length);
                    break;

                  case o.PolygonInlineArrangementType.ONE_PER_POINT:
                  default:
                    h = this.library.polygonMask.getPoingOnPolygonPathByIndex(a.length);
                }

                break;

              case o.PolygonType.INSIDE:
                h = this.library.polygonMask.getRandomPointInsidePolygonPath();
                break;

              case o.PolygonType.OUTSIDE:
                h = this.library.polygonMask.getRandomPointOutsidePolygonPath();
            }

            h && (this.x = h.x, this.y = h.y, this.initialPosition = {
              x: this.x,
              y: this.y
            });
          }
          void 0 !== this.x && void 0 !== this.y || (this.x = Math.random() * l.width, this.y = Math.random() * l.height), this.x > l.width - 2 * this.radius ? this.x = this.x - this.radius : this.x < 2 * this.radius && (this.x = this.x + this.radius), this.y > l.height - 2 * this.radius ? this.y = this.y - this.radius : this.y < 2 * this.radius && (this.y = this.y + this.radius), e.bounce && u.checkOverlap(this, {
            x: this.x,
            y: this.y
          });
        }
      }, {
        key: "setupColor",
        value: function value(e) {
          var t = this.library.getParameter(function (e) {
            return e.particles.color;
          });
          e = s.deepAssign({}, e, t), this.color = a.getColor(e.value);
        }
      }, {
        key: "setupOpacity",
        value: function value(e) {
          var t = this.library.getParameter(function (e) {
            return e.particles.opacity;
          });
          e = s.deepAssign({}, t, e), this.opacityValue = (e.random ? Math.random() : 1) * e.value, e.anim.enable && (this.opacity_status = !1, this.vo = e.anim.speed / 100, e.anim.sync || (this.vo = this.vo * Math.random()));
        }
      }, {
        key: "setupAnimation",
        value: function value(e) {
          var t,
              i = this.library.getParameter(function (e) {
            return e.particles.move;
          });

          switch ((e = s.deepAssign({}, i, e)).direction) {
            case o.MoveDirection.TOP:
              t = {
                x: 0,
                y: -1
              };
              break;

            case o.MoveDirection.TOP_RIGHT:
              t = {
                x: .5,
                y: -.5
              };
              break;

            case o.MoveDirection.RIGHT:
              t = {
                x: 1,
                y: 0
              };
              break;

            case o.MoveDirection.BOTTOM_RIGHT:
              t = {
                x: .5,
                y: .5
              };
              break;

            case o.MoveDirection.BOTTOM:
              t = {
                x: 0,
                y: 1
              };
              break;

            case o.MoveDirection.BOTTOM_LEFT:
              t = {
                x: -.5,
                y: 1
              };
              break;

            case o.MoveDirection.LEFT:
              t = {
                x: -1,
                y: 0
              };
              break;

            case o.MoveDirection.TOP_LEFT:
              t = {
                x: -.5,
                y: -.5
              };
              break;

            default:
              t = {
                x: 0,
                y: 0
              };
          }

          e.straight ? (this.vx = t.x, this.vy = t.y, e.random && (this.vx = this.vx * Math.random(), this.vy = this.vy * Math.random())) : (this.vx = t.x + Math.random() - .5, this.vy = t.y + Math.random() - .5), this.vx_i = this.vx, this.vy_i = this.vy;
        }
      }, {
        key: "setupShape",
        value: function value(e) {
          var t = this,
              i = this.library.getParameter(function (e) {
            return e.particles.shape;
          });
          e = s.deepAssign({}, i, e);
          var n = this.library.getParameter(function (e) {
            return e.particles.array;
          });

          if (Array.isArray(e.type)) {
            var r = e.type[Math.floor(Math.random() * e.type.length)];
            e = s.deepAssign({}, e, {
              type: r
            });
          }

          this.shape = e, e.type !== o.ShapeType.IMAGE && e.type !== o.ShapeType.IMAGES || (e.type === o.ShapeType.IMAGES ? this.shapeImage = this.library.imageManager.getImage(n.length) : this.shapeImage = this.library.imageManager.getImage(), "svg" === this.shapeImage.type && void 0 !== this.shapeImage.svgData && this.library.imageManager.createSvgImage(this.shapeImage.svgData, {
            color: this.color,
            opacity: this.opacityValue
          }).then(function (e) {
            t.shapeImage.elementData = e, t.shapeImage.loaded = !0;
          }));
        }
      }, {
        key: "draw",
        value: function value() {
          var e,
              t,
              i,
              n = this.library,
              r = n.canvas,
              a = n.vendors;

          if (e = void 0 !== this.radius_bubble ? this.radius_bubble : this.radius, t = void 0 !== this.bubbleOpacity ? this.bubbleOpacity : this.opacityValue, this.color.rgb) {
            var s = this.color.rgb,
                c = s.r,
                l = s.g,
                u = s.b;
            i = "rgba( ".concat(c, ", ").concat(l, ", ").concat(u, ", ").concat(t, " )");
          } else {
            var h = this.color.hsl,
                y = h.h,
                p = h.s,
                f = h.l;
            i = "hsla( ".concat(y, ", ").concat(p, ", ").concat(f, ", ").concat(t, " )");
          }

          switch (r.ctx.fillStyle = i, r.ctx.beginPath(), this.shape.type) {
            case o.ShapeType.CIRCLE:
              r.ctx.arc(this.x, this.y, e, 0, 2 * Math.PI, !1);
              break;

            case o.ShapeType.EDGE:
              r.ctx.rect(this.x - e, this.y - e, 2 * e, 2 * e);
              break;

            case o.ShapeType.TRIANGLE:
              a.drawShape(r.ctx, this.x - e, this.y + e / 1.66, 2 * e, 3, 2);
              break;

            case o.ShapeType.POLYGON:
              a.drawShape(r.ctx, this.x - e / (this.shape.polygon.nb_sides / 3.5), this.y - e / .76, 2.66 * e / (this.shape.polygon.nb_sides / 3), this.shape.polygon.nb_sides, 1);
              break;

            case o.ShapeType.STAR:
              a.drawShape(r.ctx, this.x - 2 * e / (this.shape.polygon.nb_sides / 4), this.y - e / 1.52, 2 * e * 2.66 / (this.shape.polygon.nb_sides / 3), this.shape.polygon.nb_sides, 2);
              break;

            case o.ShapeType.IMAGES:
            case o.ShapeType.IMAGE:
              this.shapeImage.elementData && r.ctx.drawImage(this.shapeImage.elementData, this.x - e, this.y - e, 2 * e, 2 * e / this.shapeImage.ratio);
          }

          r.ctx.closePath(), this.shape.stroke.width > 0 && (r.ctx.strokeStyle = this.shape.stroke.color, r.ctx.lineWidth = this.shape.stroke.width, r.ctx.stroke()), r.ctx.fill();
        }
      }]) && r(t.prototype, i), c && r(t, c), e;
    }();

    t["default"] = c;
  }, function (e, t, i) {
    "use strict";

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = i(2),
        a = i(1),
        o = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.library = t, this.particlesCreate = this.particlesCreate.bind(this);
      }

      var t, i, o;
      return t = e, (i = [{
        key: "particlesCreate",
        value: function value() {
          var e = this.library.getParameter(function (e) {
            return e.particles;
          }),
              t = this.library.getParameter(function (e) {
            return e.polygon;
          }),
              i = e.number.value;
          t.enable && t.type === a.PolygonType.INLINE && t.inline.arrangement === a.PolygonInlineArrangementType.ONE_PER_POINT && (i = this.library.polygonMask.getVerticesNumber());

          for (var n = 0; n < i; n++) {
            e.array.push(new r.Particle(this.library));
          }
        }
      }, {
        key: "particlesUpdate",
        value: function value() {
          var e = this,
              t = this.library,
              i = t.canvas,
              n = t.modes,
              o = this.library.getParameter(function (e) {
            return e.interactivity;
          }),
              s = this.library.getParameter(function (e) {
            return e.particles;
          }),
              c = this.library.getParameter(function (e) {
            return e.polygon;
          });
          s.array.forEach(function (t, l) {
            if (s.move.enable) {
              var u = s.move.speed / 2;
              t.x += t.vx * u, t.y += t.vy * u;
            }

            var h;

            switch (s.opacity.anim.enable && (1 == t.opacity_status ? (t.opacityValue >= s.opacity.value && (t.opacity_status = !1), t.opacityValue += t.vo) : (t.opacityValue <= s.opacity.anim.opacity_min && (t.opacity_status = !0), t.opacityValue -= t.vo), t.opacityValue < 0 && (t.opacityValue = 0)), s.size.anim.enable && (1 == t.size_status ? (t.radius >= s.size.value && (t.size_status = !1), t.radius += t.vs) : (t.radius <= s.size.anim.size_min && (t.size_status = !0), t.radius -= t.vs), t.radius < 0 && (t.radius = 0)), h = "bounce" == s.move.out_mode ? {
              x_left: t.radius,
              x_right: i.width,
              y_top: t.radius,
              y_bottom: i.height
            } : {
              x_left: -t.radius,
              x_right: i.width + t.radius,
              y_top: -t.radius,
              y_bottom: i.height + t.radius
            }, t.x - t.radius > i.width ? (t.x = h.x_left, t.y = Math.random() * i.height) : t.x + t.radius < 0 && (t.x = h.x_right, t.y = Math.random() * i.height), t.y - t.radius > i.height ? (t.y = h.y_top, t.x = Math.random() * i.width) : t.y + t.radius < 0 && (t.y = h.y_bottom, t.x = Math.random() * i.width), s.move.out_mode) {
              case "bounce":
                if (c.enable) {
                  var y = c.move.radius;

                  switch (c.type) {
                    case a.PolygonType.INLINE:
                      e.getDistance(t.initialPosition, t) > y && (t.vx = -t.vx + t.vy / 2, t.vy = -t.vy + t.vx / 2);
                      break;

                    case a.PolygonType.INSIDE:
                    case a.PolygonType.OUTSIDE:
                      var p = c.move.type;
                      if (p === a.PolygonMoveType.RADIUS) e.getDistance(t.initialPosition, t) > y && (t.vx = -t.vx + t.vy / 2, t.vy = -t.vy + t.vx / 2);else if (p === a.PolygonMoveType.PATH) {
                        var f = c.type === a.PolygonType.INSIDE,
                            v = e.library.polygonMask.isPointInsidePolygon({
                          x: t.x,
                          y: t.y
                        });
                        (f && !v || !f && v) && (t.vx = -t.vx + t.vy / 2, t.vy = -t.vy + t.vx / 2);
                      }
                  }
                } else t.x + t.radius > i.width ? t.vx = -t.vx : t.x - t.radius < 0 && (t.vx = -t.vx), t.y + t.radius > i.height ? t.vy = -t.vy : t.y - t.radius < 0 && (t.vy = -t.vy);

            }

            if (r.isInArray("grab", o.events.onhover.mode) && n.grabParticle(t), (r.isInArray("bubble", o.events.onhover.mode) || r.isInArray("bubble", o.events.onclick.mode)) && n.bubbleParticle(t), (r.isInArray("repulse", o.events.onhover.mode) || r.isInArray("repulse", o.events.onclick.mode)) && n.repulseParticle(t), s.line_linked.enable || s.move.attract.enable) for (var d = l + 1; d < s.array.length; d++) {
              var b = s.array[d];
              s.line_linked.enable && e.library.interactivity.linkParticles(t, b), s.move.attract.enable && e.library.interactivity.attractParticles(t, b), s.move.bounce && e.library.interactivity.bounceParticles(t, b);
            }
          });
        }
      }, {
        key: "getDistances",
        value: function value(e, t) {
          var i = e.x - t.x,
              n = e.y - t.y;
          return {
            distance: Math.sqrt(i * i + n * n),
            distanceX: i,
            distanceY: n
          };
        }
      }, {
        key: "getDistance",
        value: function value(e, t) {
          return this.getDistances(e, t).distance;
        }
      }, {
        key: "particlesDraw",
        value: function value() {
          var e = this.library,
              t = e.canvas,
              i = e.manager,
              n = this.library.getParameter(function (e) {
            return e.particles;
          }),
              r = this.library.getParameter(function (e) {
            return e.polygon;
          });
          t.ctx.clearRect(0, 0, t.width, t.height), i.particlesUpdate(), n.array.forEach(function (e) {
            e.draw();
          }), r.enable && r.draw.enable && this.library.polygonMask.drawPolygon();
        }
      }, {
        key: "particlesEmpty",
        value: function value() {
          this.library.getParameter(function (e) {
            return e.particles;
          }).array = [];
        }
      }, {
        key: "particlesRefresh",
        value: function value() {
          cancelAnimationFrame(this.library.drawAnimFrame), this.particlesEmpty(), this.library.canvasClear(), this.library.start();
        }
      }]) && n(t.prototype, i), o && n(t, o), e;
    }();

    t["default"] = o;
  }, function (e, t, i) {
    "use strict";

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = i(2),
        a = i(33),
        o = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.imageManager = new a.ImageManager(), this.retina = !1, this.onWindowResize = this.onWindowResize.bind(this), this.loadParameters(t), this.interactivity = new r.Interactivity(this), this.modes = new r.Modes(this), this.vendors = new r.Vendors(this.imageManager, this.params, this), this.manager = new r.ParticleManager(this), this.polygonMask = new r.PolygonMask(this);
      }

      var t, i, o;
      return t = e, (i = [{
        key: "getParameter",
        value: function value(e) {
          return e(this.params);
        }
      }, {
        key: "setParameters",
        value: function value(e) {
          this.params = r.deepAssign(Object.assign({}, this.params), e);
        }
      }, {
        key: "loadParameters",
        value: function value(e) {
          var t = r.deepAssign({}, r.getDefaultParams(), e);
          this.params = t;
        }
      }, {
        key: "loadCanvas",
        value: function value(e) {
          this.canvas = {
            element: e,
            width: e.offsetWidth,
            height: e.offsetHeight
          };
        }
      }, {
        key: "start",
        value: function value() {
          this.interactivity.attachEventHandlers(), this.vendors.start();
        }
      }, {
        key: "destroy",
        value: function value() {
          this.detachListeners(), this.interactivity.detachEventHandlers(), cancelAnimationFrame(this.drawAnimFrame), this.canvasClear();
        }
      }, {
        key: "detachListeners",
        value: function value() {
          window.removeEventListener("resize", this.onWindowResize);
        }
      }, {
        key: "retinaInit",
        value: function value() {
          var e = window.devicePixelRatio;

          if (this.params.retina_detect && e > 1) {
            this.canvas.pxratio = e, this.canvas.width = this.canvas.element.offsetWidth * this.canvas.pxratio, this.canvas.height = this.canvas.element.offsetHeight * this.canvas.pxratio, this.retina = !0;
            var t = this.getParameter(function (e) {
              return e;
            });
            this.setParameters({
              interactivity: {
                modes: {
                  bubble: {
                    distance: t.interactivity.modes.bubble.distance * e,
                    size: t.interactivity.modes.bubble.size * e
                  },
                  grab: {
                    distance: t.interactivity.modes.grab.distance * e
                  },
                  repulse: {
                    distance: t.interactivity.modes.repulse.distance * e
                  }
                }
              },
              particles: {
                line_linked: {
                  distance: t.particles.line_linked.distance * e,
                  width: t.particles.line_linked.width * e
                },
                move: {
                  speed: t.particles.move.speed * e
                },
                size: {
                  value: t.particles.size.value * e,
                  anim: {
                    speed: t.particles.size.anim.speed * e
                  }
                }
              }
            });
          } else this.canvas.pxratio = 1, this.retina = !1;
        }
      }, {
        key: "canvasInit",
        value: function value() {
          var e = this.canvas;
          e.ctx = e.element.getContext("2d");
        }
      }, {
        key: "canvasSize",
        value: function value() {
          var e = this.canvas;
          e.element.width = e.width, e.element.height = e.height, this.params && this.params.interactivity.events.resize && window.addEventListener("resize", this.onWindowResize);
        }
      }, {
        key: "canvasPaint",
        value: function value() {
          var e = this.canvas;
          if (e && e.ctx) try {
            e.ctx.fillRect(0, 0, e.width, e.height);
          } catch (e) {
            console.warn(e);
          }
        }
      }, {
        key: "canvasClear",
        value: function value() {
          var e = this.canvas;
          if (e && e.ctx) try {
            e.ctx.clearRect(0, 0, e.width, e.height);
          } catch (e) {
            console.warn(e);
          }
        }
      }, {
        key: "onWindowResize",
        value: function value() {
          var e = this.canvas,
              t = this.manager,
              i = this.vendors;
          e.width = e.element.offsetWidth, e.height = e.element.offsetHeight, this.retina && (e.width *= e.pxratio, e.height *= e.pxratio), e.element.width = e.width, e.element.height = e.height, !this.params.particles.move.enable || this.params.polygon.enable ? (t.particlesEmpty(), this.polygonMask.initialize(this.getParameter(function (e) {
            return e.polygon;
          })).then(function () {
            t.particlesCreate(), t.particlesDraw();
          })) : i.densityAutoParticles();
        }
      }]) && n(t.prototype, i), o && n(t, o), e;
    }();

    t["default"] = o;
  }, function (e, t, i) {
    "use strict";

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r,
        a = i(1),
        o = i(4);
    !function (e) {
      e.SINGLE = "single", e.MULTIPLE = "multiple";
    }(r = t.ImageMode || (t.ImageMode = {}));

    var s = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.singleImage = null, this.multipleImages = [], this.mode = r.SINGLE;
      }

      var t, i, s;
      return t = e, (i = [{
        key: "getImage",
        value: function value(e) {
          if (void 0 !== e) {
            if (0 === this.multipleImages.length) throw new Error("No images loaded. You may need to define 'shape.type' = 'images'.");
            return this.multipleImages[e % this.multipleImages.length];
          }

          return this.singleImage;
        }
      }, {
        key: "parseShape",
        value: function value(e) {
          var t = this;
          if (o.isEqual(a.ShapeType.IMAGE, e.type)) return this.mode = r.SINGLE, this.parseSingleImage(e.image).then(function (i) {
            return t.singleImage = i, Object.assign(Object.assign({}, e), {
              image: i
            });
          });

          if (o.isEqual(a.ShapeType.IMAGES, e.type)) {
            this.mode = r.MULTIPLE;
            var i = e.images.map(function (e) {
              return t.parseSingleImage(e);
            });
            return Promise.all(i).then(function (i) {
              return t.multipleImages = i, Object.assign(Object.assign({}, e), {
                images: i
              });
            });
          }

          return Promise.resolve(e);
        }
      }, {
        key: "parseSingleImage",
        value: function value(e) {
          var t,
              i = this.buildImageObject({
            height: e.height,
            width: e.width,
            src: e.src
          }),
              n = e.width / e.height;
          return n !== 1 / 0 && 0 !== n || (n = 1), i.ratio = n, (t = /^data:image\/(\w{3})\+xml;(.*?)base64,(.*)$/.exec(e.src)) ? (i.type = t[1], i.svgData = atob(t[3])) : (t = /^.*(\w{3})$/.exec(e.src)) && (i.type = t[1]), this.loadImage(i);
        }
      }, {
        key: "loadImage",
        value: function value(e) {
          return "" != (e = Object.assign({}, e)).src ? "svg" == e.type ? e.svgData ? Promise.resolve(e) : this.downloadImage(e.src).then(function (t) {
            return e.svgData = t.response, e;
          }) : new Promise(function (t) {
            var i = new Image();
            i.addEventListener("load", function () {
              e.elementData = i, t(e);
            }), i.src = e.src;
          }) : Promise.reject(new Error("Error react-particles-js - no image.src"));
        }
      }, {
        key: "downloadImage",
        value: function value(e) {
          return new Promise(function (t, i) {
            var n = new XMLHttpRequest();
            n.open("GET", e), n.onreadystatechange = function (e) {
              4 == n.readyState && (200 == n.status ? t({
                response: e.currentTarget.response,
                xhr: n
              }) : i(new Error("Error react-particles-js - Status code ".concat(n.readyState))));
            }, n.send();
          });
        }
      }, {
        key: "createSvgImage",
        value: function value(e, t) {
          var i = e.replace(/#([0-9A-F]{3,6})|rgb\([0-9,]+\)/gi, function (e, i, n, r) {
            var a;

            if (t.color.rgb) {
              var o = t.color.rgb,
                  s = o.r,
                  c = o.g,
                  l = o.b;
              a = "rgba( ".concat(s, ", ").concat(c, ", ").concat(l, ", ").concat(t.opacity, " )");
            } else {
              var u = t.color.hsl,
                  h = u.h,
                  y = u.s,
                  p = u.l;
              a = "rgba( ".concat(h, ", ").concat(y, ", ").concat(p, ", ").concat(t.opacity, " )");
            }

            return a;
          }),
              n = new Blob([i], {
            type: "image/svg+xml;charset=utf-8"
          }),
              r = window.URL || window,
              a = r.createObjectURL(n);
          return new Promise(function (e) {
            var t = new Image();
            t.addEventListener("load", function () {
              r.revokeObjectURL(a), e(t);
            }), t.src = a;
          });
        }
      }, {
        key: "buildImageObject",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return Object.assign({
            svgData: null,
            height: 0,
            width: 0,
            ratio: 0,
            src: "",
            type: ""
          }, e);
        }
      }]) && n(t.prototype, i), s && n(t, s), e;
    }();

    t.ImageManager = s;
  }, function (e, t, i) {
    "use strict";

    function n(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = i(2),
        a = i(1),
        o = function () {
      function e(t, i, n) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.imageManager = t, this.initialized = !1, this.params = i, this.library = n, "undefined" != typeof performance && (this.lastDraw = performance.now()), this.draw = this.draw.bind(this);
      }

      var t, i, o;
      return t = e, (i = [{
        key: "densityAutoParticles",
        value: function value() {
          var e = this.library,
              t = e.canvas,
              i = e.modes,
              n = this.params.particles,
              r = n.number.density,
              a = r.value_area;

          if (r.enable) {
            var o = t.element.width * t.element.height / 1e3;
            this.library.retina && (o /= 2 * t.pxratio);
            var s = o * n.number.value / a,
                c = n.array.length - s;
            c < 0 ? i.pushParticles(Math.abs(c)) : i.removeParticles(c);
          }
        }
      }, {
        key: "checkOverlap",
        value: function value(e, t) {
          var i = this,
              n = this.library,
              r = n.canvas,
              o = n.vendors;
          r.width && r.height && this.params.particles.array.forEach(function (n) {
            var s = n,
                c = e.x - s.x,
                l = e.y - s.y;
            if (Math.sqrt(c * c + l * l) <= e.radius + s.radius) if (i.library.params.polygon.enable) switch (i.library.params.polygon.inline.arrangement) {
              case a.PolygonInlineArrangementType.RANDOM_LENGTH:
              case a.PolygonInlineArrangementType.RANDOM_POINT:
            } else e.x = t ? t.x : Math.random() * r.width, e.y = t ? t.y : Math.random() * r.height, o.checkOverlap(e);
          });
        }
      }, {
        key: "destroy",
        value: function value() {
          cancelAnimationFrame(this.library.drawAnimFrame), this.library.canvas.element.remove();
        }
      }, {
        key: "drawShape",
        value: function value(e, t, i, n, r, a) {
          var o = r * a,
              s = r / a,
              c = 180 * (s - 2) / s,
              l = Math.PI - Math.PI * c / 180;
          e.save(), e.beginPath(), e.translate(t, i), e.moveTo(0, 0);

          for (var u = 0; u < o; u++) {
            e.lineTo(n, 0), e.translate(n, 0), e.rotate(l);
          }

          e.fill(), e.restore();
        }
      }, {
        key: "exportImg",
        value: function value() {
          var e = this.library.canvas;
          window.open(e.element.toDataURL("image/png"), "_blank");
        }
      }, {
        key: "draw",
        value: function value() {
          var e = !0,
              t = this.library,
              i = t.manager,
              n = t.vendors,
              r = this.params.particles;
          void 0 !== performance && (performance.now() - this.lastDraw < 1e3 / this.params.fps_limit ? e = !1 : this.lastDraw = performance.now()), e && i.particlesDraw(), r.move.enable ? this.library.drawAnimFrame = requestAnimationFrame(n.draw) : cancelAnimationFrame(this.library.drawAnimFrame);
        }
      }, {
        key: "init",
        value: function value() {
          var e = this;

          if (!this.initialized) {
            this.initialized = !0;
            var t = this.library,
                i = t.manager,
                n = t.vendors,
                a = this.params.particles;
            t.retinaInit(), t.canvasInit(), t.canvasSize(), t.polygonMask.initialize(this.library.getParameter(function (e) {
              return e.polygon;
            })).then(function () {
              i.particlesCreate(), n.densityAutoParticles(), e.library.setParameters({
                particles: {
                  line_linked: {
                    color_rgb_line: r.hexToRgb(a.line_linked.color)
                  }
                }
              }), e.draw();
            });
          }
        }
      }, {
        key: "start",
        value: function value() {
          var e = this,
              t = this.params.particles;
          this.imageManager.parseShape(t.shape).then(function (t) {
            e.init();
          });
        }
      }]) && n(t.prototype, i), o && n(t, o), e;
    }();

    t["default"] = o;
  }, function (e, t, i) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = i(1),
        r = i(4),
        a = {
      particles: {
        number: {
          value: 40,
          max: -1,
          density: {
            enable: !1,
            value_area: 1200
          }
        },
        color: {
          value: "#FFF"
        },
        shape: {
          type: n.ShapeType.CIRCLE,
          stroke: {
            width: 0,
            color: "#000000"
          },
          polygon: {
            nb_sides: 5
          },
          image: {
            src: "",
            width: 100,
            height: 100
          },
          images: []
        },
        opacity: {
          value: .5,
          random: !1,
          anim: {
            enable: !0,
            speed: 1,
            opacity_min: .1,
            sync: !1
          }
        },
        size: {
          value: 1,
          random: !1,
          anim: {
            enable: !1,
            speed: 40,
            size_min: 0,
            sync: !1
          }
        },
        line_linked: {
          enable: !0,
          distance: 150,
          color: "#FFF",
          opacity: .6,
          width: 1,
          shadow: {
            enable: !1,
            blur: 5,
            color: "lime"
          }
        },
        move: {
          enable: !0,
          speed: 3,
          direction: n.MoveDirection.NONE,
          random: !1,
          straight: !1,
          out_mode: n.MoveOutMode.BOUNCE,
          bounce: !0,
          attract: {
            enable: !1,
            rotateX: 3e3,
            rotateY: 3e3
          }
        },
        array: []
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onhover: {
            enable: !1,
            mode: n.InteractivityMode.GRAB
          },
          onclick: {
            enable: !1,
            mode: n.InteractivityMode.REPULSE
          },
          resize: !0
        },
        modes: {
          grab: {
            distance: 180,
            line_linked: {
              opacity: .35
            }
          },
          bubble: {
            distance: 200,
            size: 80,
            duration: .4
          },
          repulse: {
            distance: 100,
            duration: 5
          },
          push: {
            particles_nb: 4
          },
          remove: {
            particles_nb: 2
          }
        }
      },
      retina_detect: !0,
      fps_limit: 999,
      polygon: {
        enable: !1,
        scale: 1,
        type: n.PolygonType.INLINE,
        inline: {
          arrangement: n.PolygonInlineArrangementType.ONE_PER_POINT
        },
        draw: {
          enable: !1,
          stroke: {
            width: .5,
            color: "rgba(255, 255, 255, .1)"
          }
        },
        move: {
          radius: 10,
          type: n.PolygonMoveType.PATH
        },
        url: ""
      }
    };

    t.getDefaultParams = function () {
      return r.deepAssign({}, a);
    };
  }, function (e, t, i) {
    "use strict";

    function n(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
        var i = [],
            n = !0,
            r = !1,
            a = void 0;

        try {
          for (var o, s = e[Symbol.iterator](); !(n = (o = s.next()).done) && (i.push(o.value), !t || i.length !== t); n = !0) {
            ;
          }
        } catch (e) {
          r = !0, a = e;
        } finally {
          try {
            n || null == s["return"] || s["return"]();
          } finally {
            if (r) throw a;
          }
        }

        return i;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function r(e, t) {
      for (var i = 0; i < t.length; i++) {
        var n = t[i];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.library = t, this.polygonPathLength = 0, this.initialized = !1, this.path2DSupported = !!window.Path2D, this.debounceTime = 250, this.parseSvgPathToPolygon = this.parseSvgPathToPolygon.bind(this);
      }

      var t, i, a;
      return t = e, (i = [{
        key: "initialize",
        value: function value(e) {
          var t = this;
          return this.polygon = e, e.enable ? this.initialized ? new Promise(function (e) {
            t.debounceTimer && clearTimeout(t.debounceTimer), t.debounceTimer = setTimeout(function () {
              t.parseSvgPathToPolygon().then(function (t) {
                e();
              });
            }, t.debounceTime);
          }) : this.parseSvgPathToPolygon().then(function (e) {
            t.initialized = !0;
          }) : Promise.resolve();
        }
      }, {
        key: "getVerticesNumber",
        value: function value() {
          return this.initialized ? this.polygonRaw.length : 0;
        }
      }, {
        key: "parseSvgPathToPolygon",
        value: function value(e) {
          var t = this;
          e = e || this.polygon.url;
          var i = this.library.canvas.width === this.lastCanvasWidth && this.library.canvas.height === this.lastCanvasHeight;
          return this.polygonRaw && this.polygonRaw.length && i ? Promise.resolve(this.polygonRaw) : this.parseSvgPath(e).then(function (e) {
            return t.polygonData = e, t.polygonWidth = parseInt(t.polygonData.svg.getAttribute("width")) * t.polygon.scale, t.polygonHeight = parseInt(t.polygonData.svg.getAttribute("height")) * t.polygon.scale, t.polygonOffsetX = t.library.canvas.width / 2 - t.polygonWidth / 2, t.polygonOffsetY = t.library.canvas.height / 2 - t.polygonHeight / 2, t.polygonData.paths.length && (t.polygonPathLength = t.polygonData.paths[0].getTotalLength()), t.polygonRaw = [], t.polygonData.paths.forEach(function (e) {
              for (var i = e.pathSegList.numberOfItems, n = 0; n < i; n++) {
                var r = {
                  x: 0,
                  y: 0
                },
                    a = e.pathSegList.getItem(n);

                switch (a.pathSegType) {
                  case SVGPathSeg.PATHSEG_ARC_ABS:
                  case SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
                  case SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
                  case SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
                  case SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS:
                  case SVGPathSeg.PATHSEG_LINETO_ABS:
                  case SVGPathSeg.PATHSEG_MOVETO_ABS:
                    r.x = a.x, r.y = a.y;

                  case SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS:
                    r.x = a.x;
                    break;

                  case SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS:
                    r.y = a.y;
                    break;

                  case SVGPathSeg.PATHSEG_ARC_REL:
                  case SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
                  case SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
                  case SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
                  case SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL:
                  case SVGPathSeg.PATHSEG_LINETO_REL:
                  case SVGPathSeg.PATHSEG_MOVETO_REL:
                    r.x = a.x, r.y = a.y;

                  case SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL:
                    r.x = a.x;
                    break;

                  case SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL:
                    r.y = a.y;
                    break;

                  case SVGPathSeg.PATHSEG_UNKNOWN:
                  case SVGPathSeg.PATHSEG_CLOSEPATH:
                  default:
                    continue;
                }

                t.polygonRaw.push([r.x * t.polygon.scale + t.polygonOffsetX, r.y * t.polygon.scale + t.polygonOffsetY]);
              }
            }), t.lastCanvasWidth = t.library.canvas.width, t.lastCanvasHeight = t.library.canvas.height, t.createPath2D(), t.polygonRaw;
          });
        }
      }, {
        key: "parseSvgPath",
        value: function value(e) {
          return this.polygonData && this.polygonData.paths && this.polygonData.paths.length && this.polygonData.svg ? Promise.resolve(this.polygonData) : this.library.imageManager.downloadImage(e).then(function (e) {
            return {
              paths: [e.xhr.responseXML.getElementsByTagName("path")[0]],
              svg: e.xhr.responseXML.getElementsByTagName("svg")[0]
            };
          });
        }
      }, {
        key: "getRandomPointOnPolygonPath",
        value: function value() {
          if (!this.initialized) throw new Error("No polygon data loaded.");
          var e = n(this.polygonRaw[Math.floor(Math.random() * this.polygonRaw.length)], 2);
          return {
            x: e[0],
            y: e[1]
          };
        }
      }, {
        key: "getRandomPointOnPolygonPathByLength",
        value: function value() {
          if (!this.initialized) throw new Error("No polygon data loaded.");
          var e = this.polygonData.paths[0].getPointAtLength(Math.floor(Math.random() * this.polygonPathLength) + 1);
          return {
            x: e.x * this.polygon.scale + this.polygonOffsetX,
            y: e.y * this.polygon.scale + this.polygonOffsetY
          };
        }
      }, {
        key: "getRandomPointInsidePolygonPath",
        value: function value() {
          if (!this.initialized) throw new Error("No polygon data loaded.");
          var e = {
            x: Math.random() * this.library.canvas.width,
            y: Math.random() * this.library.canvas.height
          };
          return this.isPointInsidePolygon(e) ? e : this.getRandomPointInsidePolygonPath();
        }
      }, {
        key: "getRandomPointOutsidePolygonPath",
        value: function value() {
          if (!this.initialized) throw new Error("No polygon data loaded.");
          var e = {
            x: Math.random() * this.library.canvas.width,
            y: Math.random() * this.library.canvas.height
          };
          return this.isPointInsidePolygon(e) ? this.getRandomPointOutsidePolygonPath() : e;
        }
      }, {
        key: "isPointInsidePolygon",
        value: function value(e) {
          if (this.path2DSupported && this.polygonPath) return this.library.canvas.ctx.isPointInPath(this.polygonPath, e.x, e.y);

          for (var t = !1, i = 0, n = this.polygonRaw.length - 1; i < this.polygonRaw.length; n = i++) {
            var r = this.polygonRaw[i][0],
                a = this.polygonRaw[i][1],
                o = this.polygonRaw[n][0],
                s = this.polygonRaw[n][1];
            a > e.y != s > e.y && e.x < (o - r) * (e.y - a) / (s - a) + r && (t = !t);
          }

          return t;
        }
      }, {
        key: "getPoingOnPolygonPathByIndex",
        value: function value(e) {
          if (!this.initialized) throw new Error("No polygon data loaded.");
          var t = n(this.polygonRaw[e % this.polygonRaw.length], 2);
          return {
            x: t[0],
            y: t[1]
          };
        }
      }, {
        key: "getEquidistantPoingOnPolygonPathByIndex",
        value: function value(e) {
          if (!this.initialized) throw new Error("No polygon data loaded.");
          var t = this.polygonData.paths[0].getPointAtLength(this.polygonPathLength / this.library.getParameter(function (e) {
            return e.particles.number.value;
          }) * e);
          return {
            x: t.x * this.polygon.scale + this.polygonOffsetX,
            y: t.y * this.polygon.scale + this.polygonOffsetY
          };
        }
      }, {
        key: "drawPolygon",
        value: function value() {
          var e = this.library.canvas.ctx;

          if (!this.path2DSupported) {
            if (!this.initialized) return;
            e.beginPath(), e.moveTo(this.polygonRaw[0][0], this.polygonRaw[0][1]), this.polygonRaw.forEach(function (t, i) {
              var r = n(t, 2),
                  a = r[0],
                  o = r[1];
              i > 0 && e.lineTo(a, o);
            }), e.closePath();
          }

          e.strokeStyle = this.polygon.draw.stroke.color, e.lineWidth = this.polygon.draw.stroke.width, this.polygonPath ? e.stroke(this.polygonPath) : e.stroke();
        }
      }, {
        key: "createPath2D",
        value: function value() {
          var e = this;
          this.path2DSupported && (this.polygonPath = new Path2D(), this.polygonPath.moveTo(this.polygonRaw[0][0], this.polygonRaw[0][1]), this.polygonRaw.forEach(function (t, i) {
            var r = n(t, 2),
                a = r[0],
                o = r[1];
            i > 0 && e.polygonPath.lineTo(a, o);
          }), this.polygonPath.closePath());
        }
      }]) && r(t.prototype, i), a && r(t, a), e;
    }();

    t.PolygonMask = a;
  }, function (e, t, i) {
    var n = i(38);

    e.exports = function (e, t) {
      return n(e, t);
    };
  }, function (e, t, i) {
    var n = i(39),
        r = i(10);

    e.exports = function e(t, i, a, o, s) {
      return t === i || (null == t || null == i || !r(t) && !r(i) ? t != t && i != i : n(t, i, a, o, e, s));
    };
  }, function (e, t, i) {
    var n = i(40),
        r = i(22),
        a = i(75),
        o = i(79),
        s = i(101),
        c = i(13),
        l = i(23),
        u = i(25),
        h = "[object Object]",
        y = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, i, p, f, v) {
      var d = c(e),
          b = c(t),
          g = d ? "[object Array]" : s(e),
          m = b ? "[object Array]" : s(t),
          _ = (g = "[object Arguments]" == g ? h : g) == h,
          P = (m = "[object Arguments]" == m ? h : m) == h,
          x = g == m;

      if (x && l(e)) {
        if (!l(t)) return !1;
        d = !0, _ = !1;
      }

      if (x && !_) return v || (v = new n()), d || u(e) ? r(e, t, i, p, f, v) : a(e, t, g, i, p, f, v);

      if (!(1 & i)) {
        var w = _ && y.call(e, "__wrapped__"),
            O = P && y.call(t, "__wrapped__");

        if (w || O) {
          var M = w ? e.value() : e,
              E = O ? t.value() : t;
          return v || (v = new n()), f(M, E, i, p, v);
        }
      }

      return !!x && (v || (v = new n()), o(e, t, i, p, f, v));
    };
  }, function (e, t, i) {
    var n = i(5),
        r = i(46),
        a = i(47),
        o = i(48),
        s = i(49),
        c = i(50);

    function l(e) {
      var t = this.__data__ = new n(e);
      this.size = t.size;
    }

    l.prototype.clear = r, l.prototype["delete"] = a, l.prototype.get = o, l.prototype.has = s, l.prototype.set = c, e.exports = l;
  }, function (e, t) {
    e.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, i) {
    var n = i(6),
        r = Array.prototype.splice;

    e.exports = function (e) {
      var t = this.__data__,
          i = n(t, e);
      return !(i < 0) && (i == t.length - 1 ? t.pop() : r.call(t, i, 1), --this.size, !0);
    };
  }, function (e, t, i) {
    var n = i(6);

    e.exports = function (e) {
      var t = this.__data__,
          i = n(t, e);
      return i < 0 ? void 0 : t[i][1];
    };
  }, function (e, t, i) {
    var n = i(6);

    e.exports = function (e) {
      return n(this.__data__, e) > -1;
    };
  }, function (e, t, i) {
    var n = i(6);

    e.exports = function (e, t) {
      var i = this.__data__,
          r = n(i, e);
      return r < 0 ? (++this.size, i.push([e, t])) : i[r][1] = t, this;
    };
  }, function (e, t, i) {
    var n = i(5);

    e.exports = function () {
      this.__data__ = new n(), this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.__data__,
          i = t["delete"](e);
      return this.size = t.size, i;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.get(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t, i) {
    var n = i(5),
        r = i(11),
        a = i(21);

    e.exports = function (e, t) {
      var i = this.__data__;

      if (i instanceof n) {
        var o = i.__data__;
        if (!r || o.length < 199) return o.push([e, t]), this.size = ++i.size, this;
        i = this.__data__ = new a(o);
      }

      return i.set(e, t), this.size = i.size, this;
    };
  }, function (e, t, i) {
    var n = i(17),
        r = i(55),
        a = i(19),
        o = i(20),
        s = /^\[object .+?Constructor\]$/,
        c = Function.prototype,
        l = Object.prototype,
        u = c.toString,
        h = l.hasOwnProperty,
        y = RegExp("^" + u.call(h).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function (e) {
      return !(!a(e) || r(e)) && (n(e) ? y : s).test(o(e));
    };
  }, function (e, t) {
    var i;

    i = function () {
      return this;
    }();

    try {
      i = i || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (i = window);
    }

    e.exports = i;
  }, function (e, t, i) {
    var n = i(12),
        r = Object.prototype,
        a = r.hasOwnProperty,
        o = r.toString,
        s = n ? n.toStringTag : void 0;

    e.exports = function (e) {
      var t = a.call(e, s),
          i = e[s];

      try {
        e[s] = void 0;
        var n = !0;
      } catch (e) {}

      var r = o.call(e);
      return n && (t ? e[s] = i : delete e[s]), r;
    };
  }, function (e, t) {
    var i = Object.prototype.toString;

    e.exports = function (e) {
      return i.call(e);
    };
  }, function (e, t, i) {
    var n,
        r = i(56),
        a = (n = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "";

    e.exports = function (e) {
      return !!a && a in e;
    };
  }, function (e, t, i) {
    var n = i(0)["__core-js_shared__"];
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, i) {
    var n = i(59),
        r = i(5),
        a = i(11);

    e.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new n(),
        map: new (a || r)(),
        string: new n()
      };
    };
  }, function (e, t, i) {
    var n = i(60),
        r = i(61),
        a = i(62),
        o = i(63),
        s = i(64);

    function c(e) {
      var t = -1,
          i = null == e ? 0 : e.length;

      for (this.clear(); ++t < i;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    c.prototype.clear = n, c.prototype["delete"] = r, c.prototype.get = a, c.prototype.has = o, c.prototype.set = s, e.exports = c;
  }, function (e, t, i) {
    var n = i(8);

    e.exports = function () {
      this.__data__ = n ? n(null) : {}, this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, i) {
    var n = i(8),
        r = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;

      if (n) {
        var i = t[e];
        return "__lodash_hash_undefined__" === i ? void 0 : i;
      }

      return r.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, i) {
    var n = i(8),
        r = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;
      return n ? void 0 !== t[e] : r.call(t, e);
    };
  }, function (e, t, i) {
    var n = i(8);

    e.exports = function (e, t) {
      var i = this.__data__;
      return this.size += this.has(e) ? 0 : 1, i[e] = n && void 0 === t ? "__lodash_hash_undefined__" : t, this;
    };
  }, function (e, t, i) {
    var n = i(9);

    e.exports = function (e) {
      var t = n(this, e)["delete"](e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, i) {
    var n = i(9);

    e.exports = function (e) {
      return n(this, e).get(e);
    };
  }, function (e, t, i) {
    var n = i(9);

    e.exports = function (e) {
      return n(this, e).has(e);
    };
  }, function (e, t, i) {
    var n = i(9);

    e.exports = function (e, t) {
      var i = n(this, e),
          r = i.size;
      return i.set(e, t), this.size += i.size == r ? 0 : 1, this;
    };
  }, function (e, t, i) {
    var n = i(21),
        r = i(71),
        a = i(72);

    function o(e) {
      var t = -1,
          i = null == e ? 0 : e.length;

      for (this.__data__ = new n(); ++t < i;) {
        this.add(e[t]);
      }
    }

    o.prototype.add = o.prototype.push = r, o.prototype.has = a, e.exports = o;
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.set(e, "__lodash_hash_undefined__"), this;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var i = -1, n = null == e ? 0 : e.length; ++i < n;) {
        if (t(e[i], i, e)) return !0;
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e.has(t);
    };
  }, function (e, t, i) {
    var n = i(12),
        r = i(76),
        a = i(16),
        o = i(22),
        s = i(77),
        c = i(78),
        l = n ? n.prototype : void 0,
        u = l ? l.valueOf : void 0;

    e.exports = function (e, t, i, n, l, h, y) {
      switch (i) {
        case "[object DataView]":
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case "[object ArrayBuffer]":
          return !(e.byteLength != t.byteLength || !h(new r(e), new r(t)));

        case "[object Boolean]":
        case "[object Date]":
        case "[object Number]":
          return a(+e, +t);

        case "[object Error]":
          return e.name == t.name && e.message == t.message;

        case "[object RegExp]":
        case "[object String]":
          return e == t + "";

        case "[object Map]":
          var p = s;

        case "[object Set]":
          var f = 1 & n;
          if (p || (p = c), e.size != t.size && !f) return !1;
          var v = y.get(e);
          if (v) return v == t;
          n |= 2, y.set(e, t);
          var d = o(p(e), p(t), n, l, h, y);
          return y["delete"](e), d;

        case "[object Symbol]":
          if (u) return u.call(e) == u.call(t);
      }

      return !1;
    };
  }, function (e, t, i) {
    var n = i(0).Uint8Array;
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          i = Array(e.size);
      return e.forEach(function (e, n) {
        i[++t] = [n, e];
      }), i;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          i = Array(e.size);
      return e.forEach(function (e) {
        i[++t] = e;
      }), i;
    };
  }, function (e, t, i) {
    var n = i(80),
        r = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, i, a, o, s) {
      var c = 1 & i,
          l = n(e),
          u = l.length;
      if (u != n(t).length && !c) return !1;

      for (var h = u; h--;) {
        var y = l[h];
        if (!(c ? y in t : r.call(t, y))) return !1;
      }

      var p = s.get(e);
      if (p && s.get(t)) return p == t;
      var f = !0;
      s.set(e, t), s.set(t, e);

      for (var v = c; ++h < u;) {
        var d = e[y = l[h]],
            b = t[y];
        if (a) var g = c ? a(b, d, y, t, e, s) : a(d, b, y, e, t, s);

        if (!(void 0 === g ? d === b || o(d, b, i, a, s) : g)) {
          f = !1;
          break;
        }

        v || (v = "constructor" == y);
      }

      if (f && !v) {
        var m = e.constructor,
            _ = t.constructor;
        m != _ && "constructor" in e && "constructor" in t && !("function" == typeof m && m instanceof m && "function" == typeof _ && _ instanceof _) && (f = !1);
      }

      return s["delete"](e), s["delete"](t), f;
    };
  }, function (e, t, i) {
    var n = i(81),
        r = i(83),
        a = i(86);

    e.exports = function (e) {
      return n(e, a, r);
    };
  }, function (e, t, i) {
    var n = i(82),
        r = i(13);

    e.exports = function (e, t, i) {
      var a = t(e);
      return r(e) ? a : n(a, i(e));
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var i = -1, n = t.length, r = e.length; ++i < n;) {
        e[r + i] = t[i];
      }

      return e;
    };
  }, function (e, t, i) {
    var n = i(84),
        r = i(85),
        a = Object.prototype.propertyIsEnumerable,
        o = Object.getOwnPropertySymbols,
        s = o ? function (e) {
      return null == e ? [] : (e = Object(e), n(o(e), function (t) {
        return a.call(e, t);
      }));
    } : r;
    e.exports = s;
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var i = -1, n = null == e ? 0 : e.length, r = 0, a = []; ++i < n;) {
        var o = e[i];
        t(o, i, e) && (a[r++] = o);
      }

      return a;
    };
  }, function (e, t) {
    e.exports = function () {
      return [];
    };
  }, function (e, t, i) {
    var n = i(87),
        r = i(96),
        a = i(100);

    e.exports = function (e) {
      return a(e) ? n(e) : r(e);
    };
  }, function (e, t, i) {
    var n = i(88),
        r = i(89),
        a = i(13),
        o = i(23),
        s = i(92),
        c = i(25),
        l = Object.prototype.hasOwnProperty;

    e.exports = function (e, t) {
      var i = a(e),
          u = !i && r(e),
          h = !i && !u && o(e),
          y = !i && !u && !h && c(e),
          p = i || u || h || y,
          f = p ? n(e.length, String) : [],
          v = f.length;

      for (var d in e) {
        !t && !l.call(e, d) || p && ("length" == d || h && ("offset" == d || "parent" == d) || y && ("buffer" == d || "byteLength" == d || "byteOffset" == d) || s(d, v)) || f.push(d);
      }

      return f;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var i = -1, n = Array(e); ++i < e;) {
        n[i] = t(i);
      }

      return n;
    };
  }, function (e, t, i) {
    var n = i(90),
        r = i(10),
        a = Object.prototype,
        o = a.hasOwnProperty,
        s = a.propertyIsEnumerable,
        c = n(function () {
      return arguments;
    }()) ? n : function (e) {
      return r(e) && o.call(e, "callee") && !s.call(e, "callee");
    };
    e.exports = c;
  }, function (e, t, i) {
    var n = i(7),
        r = i(10);

    e.exports = function (e) {
      return r(e) && "[object Arguments]" == n(e);
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t) {
    var i = /^(?:0|[1-9]\d*)$/;

    e.exports = function (e, t) {
      var n = typeof e;
      return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && i.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
  }, function (e, t, i) {
    var n = i(7),
        r = i(26),
        a = i(10),
        o = {};
    o["[object Float32Array]"] = o["[object Float64Array]"] = o["[object Int8Array]"] = o["[object Int16Array]"] = o["[object Int32Array]"] = o["[object Uint8Array]"] = o["[object Uint8ClampedArray]"] = o["[object Uint16Array]"] = o["[object Uint32Array]"] = !0, o["[object Arguments]"] = o["[object Array]"] = o["[object ArrayBuffer]"] = o["[object Boolean]"] = o["[object DataView]"] = o["[object Date]"] = o["[object Error]"] = o["[object Function]"] = o["[object Map]"] = o["[object Number]"] = o["[object Object]"] = o["[object RegExp]"] = o["[object Set]"] = o["[object String]"] = o["[object WeakMap]"] = !1, e.exports = function (e) {
      return a(e) && r(e.length) && !!o[n(e)];
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t, i) {
    (function (e) {
      var n = i(18),
          r = t && !t.nodeType && t,
          a = r && "object" == typeof e && e && !e.nodeType && e,
          o = a && a.exports === r && n.process,
          s = function () {
        try {
          var e = a && a.require && a.require("util").types;

          return e || o && o.binding && o.binding("util");
        } catch (e) {}
      }();

      e.exports = s;
    }).call(this, i(24)(e));
  }, function (e, t, i) {
    var n = i(97),
        r = i(98),
        a = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!n(e)) return r(e);
      var t = [];

      for (var i in Object(e)) {
        a.call(e, i) && "constructor" != i && t.push(i);
      }

      return t;
    };
  }, function (e, t) {
    var i = Object.prototype;

    e.exports = function (e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || i);
    };
  }, function (e, t, i) {
    var n = i(99)(Object.keys, Object);
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (i) {
        return e(t(i));
      };
    };
  }, function (e, t, i) {
    var n = i(17),
        r = i(26);

    e.exports = function (e) {
      return null != e && r(e.length) && !n(e);
    };
  }, function (e, t, i) {
    var n = i(102),
        r = i(11),
        a = i(103),
        o = i(104),
        s = i(105),
        c = i(7),
        l = i(20),
        u = l(n),
        h = l(r),
        y = l(a),
        p = l(o),
        f = l(s),
        v = c;
    (n && "[object DataView]" != v(new n(new ArrayBuffer(1))) || r && "[object Map]" != v(new r()) || a && "[object Promise]" != v(a.resolve()) || o && "[object Set]" != v(new o()) || s && "[object WeakMap]" != v(new s())) && (v = function v(e) {
      var t = c(e),
          i = "[object Object]" == t ? e.constructor : void 0,
          n = i ? l(i) : "";
      if (n) switch (n) {
        case u:
          return "[object DataView]";

        case h:
          return "[object Map]";

        case y:
          return "[object Promise]";

        case p:
          return "[object Set]";

        case f:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = v;
  }, function (e, t, i) {
    var n = i(3)(i(0), "DataView");
    e.exports = n;
  }, function (e, t, i) {
    var n = i(3)(i(0), "Promise");
    e.exports = n;
  }, function (e, t, i) {
    var n = i(3)(i(0), "Set");
    e.exports = n;
  }, function (e, t, i) {
    var n = i(3)(i(0), "WeakMap");
    e.exports = n;
  }]);
});